import { Dialog, TextLink, Text } from 'braid-design-system';
import { type ReactNode, useId, useState } from 'react';

interface DiagramDialogProps {
  label: string;
  title: string;
  children: ReactNode;
}

export const DiagramDialog = ({
  label,
  title,
  children,
}: DiagramDialogProps) => {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Text>
        <TextLink href="" onClick={() => setOpen(true)}>
          {label}
        </TextLink>
      </Text>
      <Dialog
        id={id}
        title={title}
        open={open}
        width="large"
        onClose={() => setOpen(false)}
      >
        {children}
      </Dialog>
    </>
  );
};
